<template>
    <catalog-layout id="catalog-index-page" class="h-100">
        <catalog-page-header></catalog-page-header>

        <section id="catalog-filter-header">
            <catalog-filter-header class="my-4"></catalog-filter-header>
        </section>
        <section id="catalog-page-content">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-3">
                        <catalog-filter-sidebar></catalog-filter-sidebar>
                    </div>
                    <div class="col-12 col-lg-9">
                        <catalog-content></catalog-content>
                    </div>
                </div>
            </div>
        </section>
    </catalog-layout>
</template>

<script>
import CatalogLayout from '../../layouts/CatalogLayout.vue'
import CatalogPageHeader from "../../components/organisms/CatalogPageHeader.vue";
import CatalogFilterHeader from "../../components/organisms/CatalogFilterHeader.vue";
import CatalogFilterSidebar from "../../components/organisms/CatalogFilterSidebar.vue";
import CatalogContent from "../../components/organisms/CatalogContent.vue";

export default {
    components: {
        CatalogContent,
        CatalogFilterSidebar,
        CatalogFilterHeader,
        CatalogPageHeader,
        CatalogLayout,
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.catalog.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.catalog.description') }
            ]
        },
    }
}
</script>
